import { useEffect } from 'react';

import history from 'src/history';
import { getElectronAPI } from 'src/hooks/useElectron';

/**
 * Hook to handle deep link navigation in the Electron app.
 * Listens for deep-link:navigate IPC events and pushes the path
 * to the router history, avoiding a full page reload.
 */
export const useDeepLinkNavigation = () => {
  useEffect(() => {
    const electronAPI = getElectronAPI();
    if (!electronAPI?.onDeepLinkNavigation) return;

    return electronAPI.onDeepLinkNavigation((path) => history.push(path));
  }, []);
};
